import { useEffect, useState } from "react";
import { getAvailability } from "@/lib/availability";
import { handleAnchorClick } from "@/lib/scroll";

const AvailabilityBanner = () => {
    const [avail, setAvail] = useState(null);

    useEffect(() => {
        let active = true;
        getAvailability().then((d) => {
            if (active) setAvail(d);
        });
        return () => {
            active = false;
        };
    }, []);

    if (!avail || !avail.enabled) return null;

    return (
        <div
            data-testid="availability-banner"
            className="border-b border-brand/10 bg-ice"
        >
            <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-2 gap-y-0.5 px-4 py-2 text-center sm:px-6 lg:px-8">
                <span className="relative flex h-1.5 w-1.5">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand opacity-60" />
                    <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-brand" />
                </span>
                <p className="text-xs font-medium text-brand-deep">
                    Now booking: next project slot opens {avail.next_slot}
                    {avail.slots > 0 &&
                        ` · ${avail.slots} slot${avail.slots === 1 ? "" : "s"} available`}
                </p>
                <a
                    href="#contact"
                    data-testid="availability-banner-cta"
                    onClick={(e) => handleAnchorClick(e, "#contact")}
                    className="text-xs font-semibold text-ink underline decoration-brand/50 underline-offset-2 transition-colors duration-200 hover:text-brand-dark"
                >
                    Claim a slot
                </a>
            </div>
        </div>
    );
};

export default AvailabilityBanner;
